// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MapController from "./map_controller"
application.register("map", MapController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import PasskeyController from "./passkey_controller"
application.register("passkey", PasskeyController)

import RecaptchaController from "./recaptcha_controller"
application.register("recaptcha", RecaptchaController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TrackerController from "./tracker_controller"
application.register("tracker", TrackerController)

import TripMapController from "./trip_map_controller"
application.register("trip-map", TripMapController)

import UsgsModalController from "./usgs_modal_controller"
application.register("usgs-modal", UsgsModalController)

import WaterMapController from "./water_map_controller"
application.register("water-map", WaterMapController)
